export default __webpack_public_path__ + "static/ed-bryne-6bd5ec82aef7e7b01754eaf192531c13.png";